import React from 'react';

export default function CommunityGuidelines() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">

        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-extrabold text-blue-900 mb-2 text-center">
            Community Guidelines
          </h1>
          <p className="text-lg text-gray-700">
            Professional behavior, respectful communication, and transparent collaboration are core to the Million2Trillion (M2T) verified ecosystem.
          </p>
        </div>

        {/* Guidelines List */}
        <div className="border border-purple-200 bg-purple-50 p-6 rounded-2xl shadow mb-10">
          <ul className="list-disc space-y-6 text-gray-700 text-base px-6">
            <li><strong className="text-blue-900"> Respect for All Members:</strong> Always maintain a professional tone in public and private discussions.</li>
            <li><strong className="text-blue-900"> Zero Harassment Policy:</strong> No bullying, hate speech, personal attacks, or inflammatory behavior.</li>
            <li><strong className="text-blue-900"> Marketplace Integrity:</strong> Promote services, products, signals, or courses with full honesty and clear terms.</li>
            <li><strong className="text-blue-900"> Language &amp; Tone:</strong> Use respectful language — no abusive words, aggressive tone, or political conflicts inside platform threads.</li>
            <li><strong className="text-blue-900"> Conflict Resolution:</strong> Disputes should be handled via official moderation channels or mediation processes — no public fights or arguments.</li>
            <li><strong className="text-blue-900"> Cultural Sensitivity:</strong> M2T serves global members — respect cultural differences and avoid offensive humor or stereotypes.</li>
            <li><strong className="text-blue-900"> Personal Data Privacy:</strong> Do not share others&apos; private information, screenshots, recordings, or chat logs without permission.</li>
            <li><strong className="text-blue-900"> Marketing Ethics:</strong> No spamming, fake reviews, copy-paste promotions, or unauthorized direct messaging for sales purposes.</li>
            <li><strong className="text-blue-900"> Verified Claims Only:</strong> Trading claims, success stories, or financial statements must be verifiable — no exaggerated or fake performance posting allowed.</li>
            <li><strong className="text-blue-900"> Admin Decision Binding:</strong> Community moderators hold authority to suspend, block, or permanently remove members violating these guidelines.</li>
          </ul>
        </div>


      </div>
    </div>
  );
}
